module.exports = __webpack_public_path__ + "img/sk.f430be3d.svg";